/*@ngInject*/
const NotificationRepository = function (baseRepository, currentUserModel) {

    angular.extend(this, baseRepository);

    this.findByNotifiedUserId = function (userId, type, startingIndex, numberOfRows, latest, unreadOnly) {
        const url = '/rest/Notification/toUser';
        const config = {
            params: {
                userId: userId,
                type: type,
                startingIndex: startingIndex,
                numberOfRows: numberOfRows,
                registrationIdentifier: '/User/' + userId,
                latest: latest,
                unreadOnly: unreadOnly
            }
        };
        currentUserModel.addNotificationRegistration(type, {
            'url': url,
            'params': config.params
        });
        return this.get(url, config);
    };

    this.countUnacknowledgedByUserId = function (userId, type, latest) {
        const url = '/rest/Notification/toUser/countUnacknowledged';
        const config = {
            params: {
                userId: userId,
                type: type,
                latest: latest
            }
        };
        return this.get(url, config);
    };

    this.acknowledgeByUserId = function (userId, type) {
        const url = '/rest/Notification/acknowledgeByUserId',
            config = {
                params: {
                    userId: userId,
                    type: type
                }
            };
        return this.post(url, {}, config);
    };

    this.acknowledgeByNotificationId = function (notificationId) {
        const url = `/rest/Notification/acknowledge/${notificationId}`;
        return this.post(url);
    };

    this.markAsReadByNotificationId = function (notificationId, isRead) {
        const url = `/rest/Notification/${notificationId}/markAsRead`;
        const config = {
            params: {
                isRead: isRead
            }
        };
        return this.post(url, {}, config);
    };

    this.markAllAsReadByUserId = function (userId, type) {
        const url = '/rest/Notification/markAllAsReadByUserId';
        const config = {
            params: {
                userId: userId,
                type: type
            }
        };
        return this.post(url, {}, config);
    };

    this.countUnreadByUserId = function (userId, type, latest) {
        const url = '/rest/Notification/toUser/countUnread';
        const config = {
            params: {
                userId: userId,
                type: type,
                latest: latest
            }
        };
        return this.get(url, config);
    };
};

angular.module('umCore')
    .service('notificationRepository', NotificationRepository);
